import * as dashboardReportsActions from './dashboardReports';
import * as reportFormActions from './reportForm';

export default {
  ...dashboardReportsActions,
  ...reportFormActions,
};
